export function pollAsync<TResponse>(
  poll: () => Promise<TResponse>,
  isFinished: (result: TResponse) => boolean,
  seconds: number,
): Promise<TResponse> {
  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      poll()
        .then((res) => {
          if (isFinished(res)) {
            clearInterval(interval);
            resolve(res);
          }
        })
        .catch(reject);
    }, seconds * 1000);
  });
}

export const waitForSeconds = (seconds: number) => {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, seconds * 1000);
  });
};
